import * as React from 'react'

export default function MenuIcon(
	props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			height="32px"
			viewBox="0 0 32 32"
			width="32px"
			xmlSpace="preserve"
			{...props}>
			<path d="M4 10h24a2 2 0 000-4H4a2 2 0 000 4zm24 4H4a2 2 0 000 4h24a2 2 0 000-4zm0 8H4a2 2 0 000 4h24a2 2 0 000-4z" />
		</svg>
	)
}
